var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    fillRule: "evenodd",
    d: "M6.316 0h9.474c1.744 0 3.157 1.424 3.157 3.18v12.718c0 1.756-1.413 3.179-3.157 3.179H3.158C1.414 19.077 0 17.653 0 15.897V6.36C0 2.847 2.828 0 6.316 0m7.548 7.997a1.2 1.2 0 0 0 0-1.686 1.18 1.18 0 0 0-1.675 0l-3.89 3.917-1.57-1.474a1.18 1.18 0 0 0-1.674.059 1.2 1.2 0 0 0 .058 1.685l2.406 2.26a1.18 1.18 0 0 0 1.645-.03z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M14.21 27.026c0 2.195-1.767 3.974-3.947 3.974s-3.947-1.78-3.947-3.974 1.767-3.975 3.947-3.975 3.948 1.78 3.948 3.975M26.053 27.026c0 2.195-1.768 3.974-3.948 3.974s-3.947-1.78-3.947-3.974 1.767-3.975 3.947-3.975 3.948 1.78 3.948 3.975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M17.368 20.667H4.737v1.59c0 .828.21 1.607.579 2.286a5.52 5.52 0 0 1 4.947-3.081c3.052 0 5.526 2.49 5.527 5.564h.789c0-3.073 2.474-5.564 5.526-5.564 2.845 0 5.187 2.163 5.493 4.945A4.77 4.77 0 0 0 30 22.257V20.27h-1.754c-3.376 0-5.746-3.25-5.746-6.757v-2.996c0-1.103.527-2.041 1.196-2.68.335-.32.736-.595 1.174-.787l-.712-1.064a6.32 6.32 0 0 0-3.632-2.598v14.1c0 1.756-1.413 3.18-3.158 3.18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M26.27 9.141h-.06c-.217 0-.569.125-.883.425-.304.29-.459.636-.459.951v2.996c0 2.639 1.715 4.372 3.378 4.372H30V15.69c0-.633-.188-1.252-.539-1.777z"
  })));
};
export default SvgTruck;